(() => {
  if (window.NordsignTurnstile) return;
  let loading;
  let attempt = 0;
  window.NordsignTurnstile = {
    load() {
      if (loading) return loading;
      if (typeof window.turnstile?.render === 'function') return Promise.resolve(window.turnstile);
      loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const callbackName = `nordsignTurnstileLoaded${++attempt}`;
        const timer = setTimeout(failed, 15000);
        function cleanup() {
          clearTimeout(timer);
          delete window[callbackName];
          script.onerror = null;
        }
        function failed() {
          cleanup();
          script.remove();
          reject(new Error('Verification unavailable'));
        }
        // Async loading must use the provider callback rather than ready().
        window[callbackName] = () => {
          if (typeof window.turnstile?.render !== 'function') { failed(); return; }
          cleanup();
          resolve(window.turnstile);
        };
        script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${callbackName}`;
        script.async = true;
        script.onerror = failed;
        document.head.append(script);
      }).catch(error => { loading = null; throw error; });
      return loading;
    }
  };
})();
